import styled from "styled-components";
import { LinkButton, TimeSlotButton, Description } from "../.";
import { useState } from "react";
import { TimeSlot } from "../../types/TimeSlot";
import DateHelper from "../../helpers/DateHelper";
import { useTranslation } from "react-i18next";
import { TimeSlotButtonStyles } from "../../types/styles";
import { DescriptionStyles } from "../../types/styles";
import { NoAvailableTimesModalStyles } from "../../types/styles/NoAvailableTimesModalStyles";

const Container = styled.div<{ styles: NoAvailableTimesModalStyles }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ styles }) => styles.OverallMessageBackgroundColour};
  color: ${({ styles }) => styles.OverallMessageTextColour};
  font-size: 13px;

  > p {
    margin: 0;
  }
`;

const AvailableTimesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export type NoAvailableTimesModalProps = {
  availableTimes: TimeSlot[];
  setSelectedTimeSlot: React.Dispatch<React.SetStateAction<TimeSlot | null>>;
  selectedTime: TimeSlot | null;
  styles: TimeSlotButtonStyles &
    DescriptionStyles &
    NoAvailableTimesModalStyles;
};

export const NoAvailableTimesModal: React.FC<NoAvailableTimesModalProps> = ({
  availableTimes,
  setSelectedTimeSlot,
  selectedTime,
  styles,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const expandOrCollapseModal = () => {
    isExpanded ? setIsExpanded(false) : setIsExpanded(true);
  };

  const selectTimeSlot = (time: TimeSlot) => {
    setSelectedTimeSlot(selectedTime === time ? null : time);
  };

  return (
    <Container styles={styles} data-id="no-available-times-container">
      <Description
        styles={{
          ...styles,
          OverallGeneralTextColour: styles.OverallMessageTextColour,
        }}
        data-id="no-available-times-description"
      >
        {t("NoAvailableTimesWithinTwoHoursOfSelection")}
      </Description>
      {availableTimes.length > 0 && isExpanded && (
        <AvailableTimesContainer data-id="available-times-container">
          {availableTimes.map((time) => {
            return (
              <TimeSlotButton
                styles={styles}
                isSelected={selectedTime?.TimeSlot === time.TimeSlot}
                onClick={() => selectTimeSlot(time)}
                text={
                  time.TimeSlot.TimeSlot.length > 5
                    ? DateHelper.sliceTimeSlot(time)
                    : time.TimeSlot.TimeSlot
                }
                key={time.TimeSlot.TimeSlot}
              />
            );
          })}
        </AvailableTimesContainer>
      )}
      {availableTimes.length > 0 && (
        <LinkButton
          boldStyle
          onClick={expandOrCollapseModal}
          availableTimesCount={availableTimes.length}
          textColour={styles.OverallMessageTextColour}
        />
      )}
    </Container>
  );
};

export default NoAvailableTimesModal;
